export const Bio = {
    name: "Muhammad Noman",
    roles: [
      "Full Stack Developer",
      "Android Developer",
      "Backend Developer",
      "Programmer",
      "UI/UX Designer",
    ],
    description:
      "I offer professional Android development services, specializing in NodeJs, Kotlin and Jetpack Compose. Focused on delivering robust and user-friendly Android applications, I am dedicated to bringing your vision to life with high-quality, innovative solutions.",
    github: "https://github.com/Muhammad-Noman59",
    resume:
      "https://drive.google.com/file/d/1YHfGjn_utInA-tP25CaKelwThnAoHdu0/view?usp=drive_link",
    linkedin: "https://www.linkedin.com/in/muhammad-noman59/",
    whatsapp: "http://wa.me/+923104881573",
    facebook: "https://www.facebook.com/muhammad.noman59",
  };
  
  export const skills = [
    
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "MongoDb",
          image:
            "https://cdn.iconscout.com/icon/free/png-256/free-mongodb-3521676-2945120.png?f=webp",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    {
      title: "Android",
      skills: [
        {
          name: "Jetpack Compose",
          image:
            "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjC97Z8BResg5dlPqczsRCFhP6zewWX0X0e7fVPG-G7PuUZwwZVsi9OPoqJYkgqT2h0FI95SsmWzVEgpt8b8HAqFiIxZ98TFtY4lE0b8UrtVJ2HrJebRwl6C9DslsQDl9KnBIrdHS6LtkY/s1600/jetpack+compose+icon_RGB.png",
        },
        {
          name: "Kotlin",
          image:
            "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
        },
        {
          name: "XML",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
        },
        {
          name: "Android Studio",
          image:
            "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Figma",
          image:
            "https://cdn.prod.website-files.com/64f6a7b65b5aa4b4fbca8590/64f6dc2d7e56444752b9d4a2_figma-3d-logo.svg",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/D4E0BAQEIHo0q8byQpg/company-logo_200_200/0/1707595969041/vertexcode_logo?e=2147483647&v=beta&t=612LMmapBB0Hy8Ywl5ocKC1Ira6a5ZPZdDsgHJiwZwI",
      role: "Junior Android Developer",
      company: "Vertex Code",
      date: "Jun 2024 - Present",
      desc: "I have started the job at vertex code, my role is app development and backend development.",
      skills: [
        "Android",
        "Jetpack Compose",
        "Kotlin",
        "NodeJs",
        "XML",
        "Firebase",
        "MonogDb",
        "Api Integration",
        "Communication",
        "Github",
      ],
    },
    {
      id: 1,
      img: "https://media.licdn.com/dms/image/D4D0BAQEVKpo7J54Fow/company-logo_200_200/0/1706128909254/extremsoft_logo?e=2147483647&v=beta&t=w7UjVfjxAd6pS-XnvHwg8RUFj8pOE7otv3_VMjKifWE",
      role: "Ui/UX Designer",
      company: "Extremsoft",
      date: "Sep 2023 - Feb 2024",
      desc: "Mobile app and website design.",
      skills: [
        "UI/UX Design",
        "User Flow",
        "Wireframing",
        "Prototyping"
      ],  
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOa9a-20obY0k9qBKQEHj0yzgDrmB0vrevVQ&s",
      role: "Ui/UX Designer",
      company: "Digi Speck",
      date: "Jul 2023 - Jan 2024",
      desc: "Mobile app and website design.",
      skills: [
        "UI/UX Design",
        "User Flow",
        "Wireframing",
        "Prototyping"
      ],
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmElW2off_MC1pv2LvSrY_yYG4hn6pUtDtsQ&s",
      school: "Superior College Shahkot",
      date: "2024",
      grade: "65%",
      desc: "I completed my Intermediate in Computer Science (ICS) at Superior College Shahkot, focusing on computer science, mathematics, and physics.",
      degree: "Intermediate in Computer Science (ICS)",
    }
  ];
  
  export const projects = [
    {
      id: 9,
      title: "MediStock",
      date: "May 2024 - Jun 2024",
      description:
        "MediStock is an educational Android application for inventory management, developed as a learning project. The application consists of two separate apps: a User app and an Admin app, with backend APIs built using Flask",
      image:
        "MediStock-Cover.png",
      tags: [
        "Kotlin",
        "Jetpack Compose",
        "Flask",
        "Retrofit",
        "Api",
        "Git",
        "Android App",
        "MVVM", 
      ],
      category: "android app",
      github: "https://github.com/Muhammad-Noman59/MediStock",
      
    },
    {
      id: 3,
      title: "Big News",
      date: "April 2024 - May 2024",
      description:
        "Big News is a news app that helps you stay updated with the latest news. It is built using Jetpack Compose and Kotlin. The app uses several libraries to make the experience smooth and enjoyable. You can browse news by different categories or search for specific news articles.",
      image:
        "GitHub-Big-News-Banner.jpg",
      tags: ["Kotlin", "MVVM", "Api", "Retrofit","Jetpack Compose"],
      category: "android app",
      github: "https://github.com/Muhammad-Noman59/Big-News-App",
      
    },
    {
      id: 10,
      title: "Waves Of Food",
      date: "Feb 2024 - Mar 2024",
      description:
        "The user app lets users easily add food to their cart, manage orders, view history, and update their account. The admin app allows admins to manage food items, handle orders, track earnings, and update user and account details.",
      image:
        "food-ordring.png",
      tags: ["Kotlin", "XML", "Firebase",],
      category: "android app",
      github: "https://github.com/Muhammad-Noman59/Waves-Of-Food-Food-Ordering-Complete-App",
      
    },
    {
      id: 4,
      title: "Contact Book",
      date: "Jun 2024",
      description:
        "Contact Book is an Android application that allows users to manage their contacts efficiently. Users can add new contacts, update existing ones, delete contacts, and sort them by name or date.",
      image:
        "contact-book.png",
      tags: ["Kotlin", "MVVM", "Room Database", "Jetpack Compose"],
      category: "android app",
      github: "https://github.com/Muhammad-Noman59/Contact-Book",
    },
    {
      id: 5,
      title: "Tic Tac Toe Game",
      date: "Jun 2024",
      description:
        "This is a simple Tic Tac Toe game developed using Jetpack Compose for Android. The game allows two players to play against each other, keeps track of their scores, and counts the number of draws.",
      image:
        "tictactoe.png",
      tags: ["Kotlin", "MVVM", "Jetpack Compose"],
      category: "android app",
      github: "https://github.com/Muhammad-Noman59/Tic-Tac-Toe-Game",
    },
  ];
  
  export const TimeLineData = [
    { year: 2019, text: "Started my journey as Developer" },
    { year: 2019, text: "Learning Web development" },
    { year: 2021, text: "Learning React Js" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2022, text: "Started my journy as Frontend Developer Intern" },
    { year: 2023, text: "Started my own platform" },
  ];
